module.exports = __webpack_public_path__ + "img/1534666729.327eb7b8.jpg";